export default __webpack_public_path__ + "static/media/Doink_Disc_Golf_Product_Min.0f5eb75d.png";